import { useCallback } from 'react';
import { AppliedModifierFormData } from '../constant/applied_modifiers_constants';
import { custom_date_format } from '../../shared/utility';
import * as global_constants from '../../global_constants';
import * as AppliedModifiersConstants from '../constant/applied_modifiers_constants';
import moment = require('moment');

/**
 * Custom hook for utility functions
 */
export const useAppliedModifiersUtils = (formData: AppliedModifierFormData) => {
  const getDisplayFormatDate = useCallback((date: any) => {
    if (!date) return null;
    return moment(custom_date_format(date, global_constants.date_format[AppliedModifiersConstants.UI_CONSTANTS.DATE_FORMATS.DISPLAY_FORMAT]));
  }, []);

  const convertInDateFormat = useCallback((date: any) => {
    if (date) {
      return date.format(AppliedModifiersConstants.UI_CONSTANTS.DATE_FORMATS.API_FORMAT);
    }
    return null;
  }, []);

  // Memoized computation for to_charge_by values to avoid recalculation on every render
  const getMemoizedToChargeByValues = useCallback(() => {
    return formData.to_charge_by.map(item => item.value);
  }, [formData.to_charge_by]);

  return {
    getDisplayFormatDate,
    convertInDateFormat,
    getMemoizedToChargeByValues
  };
};
